<div nxRow>
    <div nxCol="12">
        <p>{{"login.redirect" | translate}}</p>
    </div>
</div>